import PropTypes from 'prop-types';
import React from 'react';
import {default as FormSelect} from '@homeaway/react-form-select';
import './FlagDropdown.less';

/* istanbul ignore next */
const noop = () => {};

function FlagDropdown({countryCode, id, items, l10n, onChange, phoneCode}) {
    return (
        <>
            <FormSelect
                id={id}
                className="InputTel__select"
                name={id}
                items={items}
                label={l10n['reactInputTel.input.countryCode']}
                value={countryCode}
                onChange={onChange}
            />
            <span className="InputTel__phone-code">{`+${phoneCode}`}</span>
        </>
    );
}

FlagDropdown.propTypes = {
    countryCode: PropTypes.string,
    id: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
        })
    ),
    l10n: PropTypes.PropTypes.shape({
        'reactInputTel.input.countryCode': PropTypes.string,
        'reactInputTel.input.label': PropTypes.string,
    }),
    onChange: PropTypes.func,
    phoneCode: PropTypes.string,
};

FlagDropdown.defaultProps = {
    flagData: [],
    onChange: noop,
};

export default FlagDropdown;
